/**
 * Ingresso (public ticketing) kill switch.
 * PostHog key: is_ingresso_enabled (fail closed).
 */
export const isIngressoFeatureEnabled = (posthogEnabled: boolean): boolean =>
  posthogEnabled;
